export default "__VITE_ASSET__aAuHaoUf__"